/* eslint-disable jira/restricted/fedramp-isolated-cloud */
import { userSegRedirectEntrypoint } from '@jira/redirect-entrypoints__user-seg-redirect/src/userSegRedirectEntrypoint.entrypoint.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';

import { settingsEntryPoint } from '@jira/spa-apps__project-settings-service-desk-virtual-agent-settings/src/settingsEntryPoint.entrypoint.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { APP_NAMES, toPackageName } from '@jira/servicedesk__common/src/toPackageName.tsx';
import { isFeatureEnabled } from '@atlassiansox/frontend-feature-encoding';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { settingsRoute } from '@jira/router-routes__project-settings-service-desk-virtual-agent-routes/src/settingsRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { VirtualAgentSettingsSkeleton } from '@jira/platform__skeletons/src/ui/virtual-agent/settings/VirtualAgentSettingsSkeleton.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { isFedRamp } from '@atlassian/atl-context';
import type { Route } from '@atlassian/react-resource-router';
import { FedRAMPFallbackRedirectToProjectSettings } from './common/index.tsx';

const settingsPageEntryPoint = createPageEntryPoint({
	main: settingsEntryPoint,
	redirect: userSegRedirectEntrypoint,
});

export const settingsRouteEntry: Route = createEntry(settingsRoute, () => ({
	group: 'project-settings-servicedesk',
	layout: serviceProjectLayout,

	navigation: {
		menuId: MenuIdProjects,
		sidebarId: SidebarIdProjectSettings,
	},

	entryPoint() {
		if (
			fg('aem_rr_sd_virtual_agent')
				? !isFeatureEnabled('jira-service-management', 'jsm-virtual-service-agent')
				: isFedRamp()
		) {
			return undefined;
		}
		return settingsPageEntryPoint;
	},

	// this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
	// eslint-disable-next-line no-restricted-syntax
	component: FedRAMPFallbackRedirectToProjectSettings,

	skeleton: VirtualAgentSettingsSkeleton,
	resources: [...getServiceDeskSettingsResources(), getConsolidationStateResource()],

	meta: {
		reporting: {
			id: APP_NAMES.VIRTUAL_AGENT_SETTINGS,
			packageName: toPackageName(APP_NAMES.VIRTUAL_AGENT_SETTINGS),
			teamName: 'jsd-flux-capacitors',
		},
	},

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
